import { Breadcrumb, Upload, Typography, Checkbox, Row, Col, Button, Space, Form, Alert, Input, Select, InputNumber, Switch, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import AdminModal from "./AdminModal";
import dayjs from 'dayjs';
import SmallCalendar from '../../schedule_timeline/SmallCalendar';


const { RangePicker } = DatePicker;
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => (value === "" || !value) ? { ...all } : { ...all, [key]: value }, {})
}
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const AdminClassModal = ({
    propsForm,
    ...props
}) => {
    const [is_resign, set_is_resign] = useState(true);
    const [environment, set_environment] = useState([]);
    const [class_name, set_class_name] = useState();
    const [count, setCount] = useState(0);
    const [show, set_show] = useState(false);
    const [classTime, setClassTime] = useState([]);
    const [classWeek, setClassWeek] = useState([])
    const [holiday, set_holiday] = useState([]);
    const [lesson_category, set_lesson_category] = useState([]);
    const [teacher_list, set_teahcer_list] = useState([]);
    const [smallCalendarKey, setSmallCalendarKey] = useState(0)
    const [form] = Form.useForm();
    const [classTimeRange, setClassTimeRange] = useState([])
    const [weekdayValue, setWeekdayValue] = useState([])
    const onHolidayChange = (e) => {
        let selected_week = []
        e && e.map((item, i) => {
            selected_week.push({
                ...item,
                text: `${item.date}(${item.week})為${item.description}`,
            })
        })
        // if (props.editcard.class_time_end_default != undefined && props.editcard.class_time_end_default != '' &&
        //     props.editcard.class_time_start_default != undefined && props.editcard.class_time_start_default != "") {
        //     set_holiday(selected_week);
        // }
        set_holiday(selected_week);
    }
    useEffect(() => {
        if (holiday.length !== 0) {
            set_show(true);
        }
    }, [holiday])
    useEffect(() => {
        setSmallCalendarKey(pre => pre + 1)
    }, [props.class_week, props.class_date])
    useEffect(() => {
        if (props.editcard.class_week != undefined && props.editcard.class_week.length != 0) {
            let data_tmp = [];
            props.editcard.class_week.map((item, i) => {
                let data_json_tmp = {};
                data_json_tmp['key'] = i;
                data_json_tmp['id'] = item.emergency_contact_id;
                data_json_tmp['day'] = item.day;
                setCount(count + 1);
                data_tmp.push(data_json_tmp);
            })
            props.set_class_week(data_tmp)
        }
    }, [props.editcard.class_week])
    useEffect(() => {
        get_teacher();
        axios
            .get('/cramSchool/api/lesson')
            .then((response) => {
                set_lesson_category(response.data?.data ?? [].map(map_item => {
                    return {
                        value: map_item.lesson_id,
                        label: map_item.name,
                    };
                }))
            })
        axios
            .get('/cramSchool/api/surrounding')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['surrounding_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_environment(data_tmp);
            })
        axios
            .get('/cramSchool/api/class_time')
            .then((response) => {
                setClassTime(response.data.data.map(map_item => {
                    return {
                        value: map_item?.time_id,
                        label: `${map_item['time_start']}-${map_item['time_end']}`,
                    };
                }))

            })
        axios
            .get('/cramSchool/api/class/coding')
            .then((response) => {
                setClassWeek(response.data.first.map(map_item => {
                    return {
                        value: map_item.id,
                        label: `${map_item['week_name']}`,
                    };
                }))
            })
    }, [])
    const get_teacher = () => {
        axios
            .get('/cramSchool/api/teacher', {
                params: {
                    is_resign: is_resign
                }
            })
            .then((response) => {
                let data_tmp = response.data.data.filter(item => item.name != null);
                set_teahcer_list(data_tmp.map(map_item => {
                    return {
                        value: map_item.teacher_id,
                        label: map_item.name,
                    };
                }))
            })
    }
    const onFinish = (values) => {
        let grade_class_id = values?.grade_class_id
        let teacher_data = values?.teacher_id.map((value) => {
            return {
                teacher_id: value
            }
        })
        let class_time_start_default = dayjs(values?.class_time[0]).format("YYYY-MM-DD")
        let class_time_end_default = dayjs(values?.class_time[1]).format("YYYY-MM-DD")
        let week_time_data = values?.week_time_data.map((value) => {
            let week_time_data_obj = {
                ...value,
                grade_class_week_time_id: value?.grade_class_week_time_id,
                grade_class_id: grade_class_id,
            }
            week_time_data_obj = setParamsFilter(week_time_data_obj)
            return {
                ...week_time_data_obj
            }

        })
        let lesson_class_data = [{ lesson_id: values?.lesson_id }]
        delete values.teacher_id
        delete values.lesson_id
        delete values.class_time
        delete values.grade_class_id

        values = {
            ...values,
            lesson_class_data,
            teacher_data,
            class_time_start_default,
            class_time_end_default,
            week_time_data,
        }
        if (props.edit) {
            props.handleEdit(values)
        }
        else {
            props.handleSubmit(values)
        }
    }
    const onWeekTimeDataChange = () => {
        let week_time_data = []

        if (propsForm) {
            week_time_data = propsForm.getFieldValue("week_time_data") ?? []
        }
        else {
            week_time_data = form.getFieldValue("week_time_data") ?? []

        }
        week_time_data.reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []);
        setWeekdayValue((pre) => {
            return week_time_data.map((value) => {
                return value?.week_id
            })
        })
        setSmallCalendarKey(pre => pre + 1)
    }

    useEffect(() => {
        if (props.open) {
            let newClassTimeRange = []
            if (propsForm) {
                let class_time_start_default = propsForm.getFieldValue("class_time_start_default")
                let class_time_end_default = propsForm.getFieldValue("class_time_end_default")
                newClassTimeRange = [class_time_start_default, class_time_end_default]
            }
            else {
                let class_time_start_default = propsForm.getFieldValue("class_time_start_default")
                let class_time_end_default = propsForm.getFieldValue("class_time_end_default")
                newClassTimeRange = [class_time_start_default, class_time_end_default]
            }
            setClassTimeRange(newClassTimeRange)
            onWeekTimeDataChange()
        }
    }, [props.open])
    useEffect(() => {
        get_teacher();
    }, [is_resign])
    useEffect(() => {
        get_teacher();
        axios
            .get('/cramSchool/api/lesson')
            .then((response) => {
                set_lesson_category(response.data.data.map(map_item => {
                    return {
                        value: map_item.lesson_id,
                        label: map_item.name,
                    };
                }))

            })

        axios
            .get('/cramSchool/api/surrounding')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['surrounding_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_environment(data_tmp);
            })
    }, [])
    const onChange = (checked) => {
        if (checked == false) {
            props.setEditCard(prev => ({ ...prev, enroll_status: false }))
        } else {
            props.setEditCard(prev => ({ ...prev, enroll_status: true }))
        }
    };
    const ModelComfirm = (file_ids) => {
        if (propsForm) {
            propsForm.setFieldValue("file_id", file_ids)
            propsForm.submit()
        }
        else {
            form.setFieldValue("file_id", file_ids)
            form.submit()
        }
    }

    return (
        <>
            <AdminModal
                {...props}
                handleSubmit={(file_ids) => { ModelComfirm(file_ids) }}
                handleEdit={(file_ids) => { ModelComfirm(file_ids) }}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
                </>)}
                uploads
            >
                <Row>
                    <Col span={24}>
                        <Form
                            labelCol={
                                {
                                    lg: {
                                        span: 6,
                                    },
                                    sm: {
                                        span: 6,
                                    },
                                }}
                            wrapperCol={
                                {
                                    lg: {
                                        span: 18,
                                    },
                                    sm: {
                                        span: 18,
                                    },
                                }
                            }

                            form={propsForm ? propsForm : form}
                            onFinish={onFinish}
                            scrollToFirstError
                        >
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Form.Item
                                    hidden
                                    initialValue={[]}
                                    name={"file_id"}
                                >
                                    <Input>
                                    </Input>
                                </Form.Item>
                                <Form.Item
                                    name={"grade_class_id"}
                                >
                                </Form.Item>
                                <Col span={24}>
                                    <Form.Item
                                        label={"課程名稱"}
                                        name={"lesson_id"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇課程（必填）"
                                            }
                                        ]}
                                    >
                                        <Select
                                            style={{
                                                width: 300,
                                            }}
                                            placeholder='請選擇課程（必填）'
                                            options={lesson_category}>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"課程編號"}
                                        name={"name_serial"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請填寫編號（必填"
                                            }
                                        ]}
                                    >
                                        <Input
                                            style={{
                                                width: 300,
                                            }}
                                            labelInValue
                                            placeholder='請填寫編號（必填）'
                                        >
                                        </Input>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"班級名稱"}
                                        name={"name"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請填寫編號（必填"
                                            }
                                        ]}
                                    >
                                        <Input
                                            style={{
                                                width: 200,
                                            }}
                                            placeholder='請輸入班級名稱（必填）'
                                        >
                                        </Input>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"老師列表"}
                                    >
                                        <Checkbox
                                            checked={is_resign ? true : false}
                                            onChange={(e) => {
                                                set_is_resign(e.target.checked)
                                            }}
                                        >
                                            隱藏離職人員
                                        </Checkbox>
                                    </Form.Item>

                                    <Form.Item
                                        label={"授課老師"}
                                        name={"teacher_id"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇教師（必填)"
                                            }
                                        ]}
                                    >
                                        <Select
                                            mode='multiple'
                                            options={teacher_list}
                                        >

                                        </Select>
                                    </Form.Item>
                                </Col>

                                {/* <Col span={24}>

                                    <Form.Item
                                        label={"招生日期"}
                                        name={"admission_class_time"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇招生日期（必填)"
                                            }
                                        ]}
                                    >
                                        <RangePicker
                                            format={"YYYY-MM-DD"}
                                        />
                                    </Form.Item>
                                </Col> */}

                                <Col span={24}>

                                    <Form.Item
                                        label={"招生人數"}
                                        name={"upper_limit_people"}
                                    >
                                        <InputNumber
                                            min={0}
                                        ></InputNumber>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>

                                    <Form.Item
                                        label={"授課日期"}
                                        name={"class_time"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇授課日期（必填)"
                                            }
                                        ]}
                                    >
                                        <RangePicker
                                            format={"YYYY-MM-DD"}
                                            onChange={(_, dateString) => {
                                                setClassTimeRange(dateString)
                                                setSmallCalendarKey((pre => pre + 1))
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>

                                    <Form.Item
                                        label={"授課教室"}
                                        name={"surrounding_id"}
                                    >
                                        <Select
                                            placeholder='請選擇授課教室'
                                            options={environment}
                                        >
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>

                                    <Form.List

                                        name={"week_time_data"}
                                    >
                                        {(fields, { add, remove }) => (
                                            <Row gutter={[4, 4]}>
                                                <Col span={6}>
                                                    <Row justify={"end"}>
                                                        <Col>
                                                            <Typography.Text>
                                                                授課時間：
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>

                                                </Col>
                                                <Col>
                                                    <Button
                                                        type='primary'
                                                        onClick={() => add()}
                                                    >新增授課時間
                                                    </Button>
                                                </Col>
                                                <Col span={24}>
                                                    {fields.map((field) => (
                                                        <Row>
                                                            <Col>
                                                                <Form.Item
                                                                    hidden
                                                                    name={[field.name, "grade_class_week_time_id"]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8}>
                                                                <Form.Item
                                                                    labelCol={
                                                                        {
                                                                            lg: {
                                                                                span: 12,
                                                                            },

                                                                        }}
                                                                    wrapperCol={
                                                                        {
                                                                            lg: {
                                                                                span: 12,
                                                                            },
                                                                        }
                                                                    }
                                                                    label="星期"
                                                                    name={[field.name, 'week_id']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "請選擇 （必填)"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        style={{
                                                                            width: 70,
                                                                        }}
                                                                        options={classWeek}
                                                                        onChange={(e) => {
                                                                            onWeekTimeDataChange()
                                                                        }}
                                                                    ></Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={14}>
                                                                <Form.Item
                                                                    label="時間段"
                                                                    name={[field.name, 'time_id']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "請選擇 （必填)"
                                                                        }
                                                                    ]}
                                                                    labelCol={
                                                                        {
                                                                            lg: {
                                                                                span: 8,
                                                                            },

                                                                        }}
                                                                    wrapperCol={
                                                                        {
                                                                            lg: {
                                                                                span: 16,
                                                                            },
                                                                        }
                                                                    }
                                                                >
                                                                    <Select
                                                                        style={{ width: 150 }}
                                                                        options={classTime}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col >
                                                                <Form.Item
                                                                    hidden
                                                                    name={[field.name, "grade_class_week_time_id"]}
                                                                >
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={1}>
                                                                {/* <Form.Item> */}
                                                                <DeleteOutlined
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        remove(field.name);
                                                                        onWeekTimeDataChange();
                                                                    }}
                                                                />
                                                                {/* </Form.Item> */}
                                                            </Col>


                                                        </Row>
                                                    ))}
                                                </Col>
                                            </Row>
                                        )}
                                    </Form.List>
                                </Col>
                                {show &&
                                    holiday && holiday.map((value, i) => {
                                        return (
                                            < Col span={24}>
                                                <Alert message={value.text} type="warning" showIcon
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary">
                                                                停課
                                                            </Button>
                                                            {/* <Button size="small" danger ghost>
                                                                調課
                                                            </Button> */}
                                                        </Space>
                                                    } />
                                            </Col>
                                        )
                                    })
                                }

                                <Form.Item
                                    label={"授課預覽"}
                                >
                                    <SmallCalendar
                                        key={smallCalendarKey}
                                        onHolidayChange={onHolidayChange}
                                        date_range_values={classTimeRange}  // RangePicker 的 dateString value
                                        default_weekday_value={weekdayValue}  // 星期幾：0是星期天，1是星期一，以此類推... 6是星期六
                                        circle_item={[]}
                                        class_name_value={class_name}  // 課程名稱
                                        make_up_date_value={[
                                            {
                                                "is_make_up": "1",
                                                "original_date": "2023-09-29",
                                                "make_up_date": "2023-09-20"
                                            },
                                            {
                                                "is_make_up": "0",
                                                "original_date": "2023-10-10"
                                            }
                                        ]}
                                    />
                                    {/* )} */}
                                </Form.Item>
                                <Col span={24}>
                                    <Form.Item
                                        label={"招生狀態"}
                                        name={"enroll_status"}
                                        valuePropName="checked"
                                    >
                                        <Switch
                                        // checked={props.editcard.enroll_status === true ? true : false}
                                        // onChange={onChange}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"課程內容"}
                                        name={"content"}
                                        initialValue={""}
                                    >
                                        <Input.TextArea
                                        />
                                    </Form.Item>
                                </Col>
                            </Row >
                        </Form>
                    </Col>
                </Row>
                <Row hidden gutter={[8, 8]} align={'middle'}>
                    <Col span={7}>
                        課程名稱
                    </Col>
                    <Col span={17}>
                        <Select
                            style={{
                                width: '100%',
                            }}
                            labelInValue
                            value={props.editcard.lesson_name}
                            placeholder='請選擇課程（必填）'
                            name="title"
                            onChange={value =>
                                props.setEditCard(prev => ({
                                    ...prev,
                                    lesson_name: value.label,
                                    lesson_class_data: [{
                                        lesson_id: value.value,
                                        lesson_name: value.label,
                                    }]
                                })
                                )}
                            options={lesson_category}>
                        </Select>
                    </Col>
                    <Col span={7}>
                        班級名稱
                    </Col>
                    <Col span={17}>
                        <Row justify={'start'}>
                            <Col span={17}>
                                <Input placeholder={'請輸入班級名稱（必填）'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(prev => ({ ...prev, name: e.target.value }))} />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={7}>
                        班級編號
                    </Col>
                    <Col span={17}>
                        <Input placeholder={'請輸入班級編號'} type='text' value={props.editcard.name_serial} name="name_serial" onChange={e => props.setEditCard(prev => ({ ...prev, name_serial: e.target.value }))} />
                    </Col>
                    <Col span={7}>
                        環境名稱
                    </Col>
                    <Col span={17}>
                        <Select
                            style={{
                                width: '100%',
                            }}
                            labelInValue
                            value={props.editcard.surrounding_name}
                            placeholder='請選擇環境'
                            name="title"
                            onChange={(value) => {
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            surrounding_id: value['value'],
                                            surrounding_name: value['label']
                                        }
                                    )
                                });
                            }}
                            options={environment}>
                        </Select>
                    </Col>
                    <Col span={24}>
                        <Row justify={'space-between'}>
                            <Col span={7}>
                                授課老師
                            </Col>
                            <Col span={10} onChange={e => set_is_resign(e.target.checked)}><Checkbox checked={is_resign ? true : false}>隱藏離職人員</Checkbox></Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Checkbox.Group
                            style={{
                                width: '100%',
                            }}
                            value={props.editcard.teacher_data && props.editcard.teacher_data.map((item) => item.teacher_id)}
                            onChange={checkedValues => {
                                let data_tmp = [];
                                checkedValues.map((item) => { data_tmp.push({ 'teacher_id': item }) });
                                props.setEditCard(
                                    pre => ({
                                        ...pre,
                                        teacher_data: data_tmp
                                    }))
                            }}
                        >
                            <Row>
                                {teacher_list && teacher_list.map((item, i) => {
                                    return (
                                        <Col span={8}>
                                            <Checkbox value={item['value']}>{item['label']}</Checkbox>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </Checkbox.Group>
                    </Col>
                    <Col span={7}>
                        最高上限人數
                    </Col>
                    <Col span={17}>

                        <Space wrap={false}>
                            <Input placeholder={'請輸入最高上限人數'} type='number' value={props.editcard.upper_limit_people} name="upper_limit_people" onChange={e => props.setEditCard(prev => ({ ...prev, upper_limit_people: e.target.value }))} min={0} />
                        </Space>
                    </Col>
                    <Col span={7}>
                        招生狀態
                    </Col>
                    <Col span={17}>

                        <Col span={17}>
                            <Switch checked={props.editcard.enroll_status == true ? true : false} onChange={onChange} />
                        </Col>
                    </Col>
                    <Col span={7}>課程內容</Col>
                    <Col span={17}>
                        <Input.TextArea value={props.editcard.content} onChange={e => props.setEditCard(prev => ({ ...prev, content: e.target.value }))} />
                    </Col>

                </Row>
            </AdminModal >
        </>
    )

}
export default AdminClassModal;